export const splitCamelCase = (input: string): string => {
  return input.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
};

export const replacePercent = (unit: string): string => {
  return unit.replace('Percent', '%');
};

export const splitCamelCaseExcluding = (input: string, excludedWords: string[]): string => {
  // Early return if nothing to exclude
  if (!excludedWords || excludedWords.length === 0) {
    return splitCamelCase(input);
  }

  const escapeRegex = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // Sort longest-first to avoid partial overlaps
  const sortedExcluded = [...excludedWords].sort((a, b) => b.length - a.length);

  // Replace excluded tokens with simple stable placeholders
  let working = input;
  const placeholders: { [key: string]: string } = {};
  sortedExcluded.forEach((word, index) => {
    const placeholder = `<<TPL${index}>>`;
    placeholders[placeholder] = word;
    working = working.replace(new RegExp(escapeRegex(word), 'g'), placeholder);
  });

  // Split underscores and camelCase on the rest
  working = splitCamelCase(working.replace(/_/g, ' '));

  // Ensure placeholders have a space boundary on both sides if concatenated
  working = working.replace(/(\S)(<<TPL\d+>>)/g, '$1 $2').replace(/(<<TPL\d+>>)(\S)/g, '$1 $2');

  // Restore originals
  Object.entries(placeholders).forEach(([placeholder, original]) => {
    working = working.replace(new RegExp(escapeRegex(placeholder), 'g'), original);
  });

  return working.replace(/\s+/g, ' ').trim();
};
